export default __webpack_public_path__ + "static/media/Scope-1.cbffd7f7.png";